import { useState, useEffect } from "react";
import { Menu, X, Send, Twitter, Flame } from "lucide-react";
import { TELEGRAM_URL, X_URL } from "@/lib/links";
import { isPresaleLive } from "@/lib/presale";
import { BuyPinkSaleButton } from "@/components/BuyPinkSaleButton";

const links = [
  { label: "Mission", href: "#mission" },
  { label: "Tokenomics", href: "#tokenomics" },
  { label: "Markets", href: "#markets" },
  { label: "Roadmap", href: "#roadmap" },
  { label: "FAQ", href: "#faq" },
  { label: "Transparency", href: "/transparency" },
  { label: "Whitepaper", href: "/whitepaper" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const live = isPresaleLive();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/70 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="px-6 md:px-12 max-w-7xl mx-auto flex items-center justify-between h-20">
        <a href="#top" data-testid="nav-logo" className="flex items-center group">
          <img src="/logo-header.png" alt="AfterBurn $AFTBRN logo" className="h-11 sm:h-12 w-auto object-contain group-hover:scale-105 transition-transform" />
        </a>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-muted-foreground hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href={X_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-x-btn"
            aria-label="Follow us on X"
            className="w-11 h-11 border border-white/15 flex items-center justify-center text-muted-foreground hover:border-ember hover:text-ember transition-colors"
          >
            <Twitter className="w-5 h-5" />
          </a>
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="nav-telegram-btn"
            aria-label="Join our Telegram"
            className="w-11 h-11 border border-white/15 flex items-center justify-center text-muted-foreground hover:border-ember hover:text-ember transition-colors"
          >
            <Send className="w-5 h-5" />
          </a>
          {live ? (
            <BuyPinkSaleButton
              testId="nav-presale-btn"
              label="Buy on PinkSale"
              className="inline-flex items-center gap-2 bg-ember text-black font-bold text-sm px-6 py-3 rounded-none hover:bg-ember-light transition-colors"
            />
          ) : (
            <a
              href="/#presale"
              data-testid="nav-presale-btn"
              className="inline-flex items-center gap-2 bg-ember text-black font-bold text-sm px-6 py-3 rounded-none hover:bg-ember-light transition-colors"
            >
              <Flame className="w-4 h-4" />
              Join Waitlist
            </a>
          )}
        </div>

        <button
          className="md:hidden text-foreground"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/95 px-6 py-6 space-y-4">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-muted-foreground hover:text-foreground"
              data-testid={`nav-mobile-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
          {live ? (
            <BuyPinkSaleButton
              testId="nav-mobile-presale-btn"
              label="Buy on PinkSale"
              className="w-full flex items-center justify-center gap-2 bg-ember text-black font-bold text-center px-6 py-3"
              onNavigate={() => setOpen(false)}
            />
          ) : (
            <a
              href="/#presale"
              onClick={() => setOpen(false)}
              className="flex items-center justify-center gap-2 bg-ember text-black font-bold text-center px-6 py-3"
              data-testid="nav-mobile-presale-btn"
            >
              <Flame className="w-4 h-4" /> Join Waitlist
            </a>
          )}
          <a
            href={TELEGRAM_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => setOpen(false)}
            className="flex items-center justify-center gap-2 border border-white/15 text-foreground/90 px-6 py-3 hover:border-ember hover:text-ember transition-colors"
            data-testid="nav-mobile-telegram-btn"
          >
            <Send className="w-4 h-4" /> Telegram
          </a>
          <a
            href={X_URL}
            target="_blank"
            rel="noreferrer"
            onClick={() => setOpen(false)}
            className="flex items-center justify-center gap-2 border border-white/15 text-foreground/90 px-6 py-3 hover:border-ember hover:text-ember transition-colors"
            data-testid="nav-mobile-x-btn"
          >
            <Twitter className="w-4 h-4" /> Follow on X
          </a>
        </div>
      )}
    </header>
  );
}
